
export const strongTranslationsHE = {
  "G11": {
    m: "אברהם",
    d: "הפטריארך אברהם, אבי המאמינים.",
    u: "משמש 73 פעמים בברית החדשה. מודל האמונה.",
    e: "מעברית אַבְרָהָם (אברהם) = אב המון"
  },
  "G25": {
    m: "לאהוב באהבה אלוהית ובלתי מותנית",
    d: "לאהוב באהבה נדיבה, מקריבה ואלוהית. זוהי האהבה של אלוהים לאנושות והאהבה שבה עלינו לאהוב זה את זה.",
    u: "משמש 143 פעמים בברית החדשה. מתאר אהבה אלוהית, מושלמת ובלתי מותנית.",
    e: "מ-ἄγω (אגו) = להוביל, להדריך לטוב"
  },
  "G26": {
    m: "אהבה אלוהית, חסד",
    d: "האהבה המושלמת של אלוהים; אהבת אחים, חיבה, רצון טוב, חסד. האהבה המאחדת את אלוהים והאדם, והאדם עם רעהו.",
    u: "משמש 116 פעמים בברית החדשה. המילה המרכזית בנצרות לתיאור האהבה האלוהית.",
    e: "נגזר מ-ἀγαπάω (אגאפאו)"
  },
  "G27": {
    m: "אהוב, יקר",
    d: "אהוב, יקר; אהוב על ידי אלוהים או בני אדם.",
    u: "משמש 61 פעמים בברית החדשה. בנו האהוב של אלוהים.",
    e: "מ-ἀγαπάω (אגפאו) = לאהוב"
  },
  "G32": {
    m: "מלאך, שליח",
    d: "שליח; מלאך שמימי בשירות אלוהים.",
    u: "משמש 175 פעמים בברית החדשה. מלאכי אלוהים.",
    e: "מ-ἀγγέλλω (אנגלו) = להכריז"
  },
  "G36": {
    m: "ממוצא נמוך, נבזה",
    d: "ללא אצילות, ממוצא נמוך; נבזה.",
    u: "משמש פעם אחת בברית החדשה (1 קורינתים 1:28).",
    e: "מ-ἀ- (שלילה) + γένος (גנוס) = לידה"
  },
  "G93": {
    m: "אי-צדק, עוולה",
    d: "הפרת זכות, אי-צדק; רשעות, עוולה מוסרית.",
    u: "משמש 25 פעמים בברית החדשה. הפוך מ-δικαιοσύνη (צדק).",
    e: "מ-ἀ- (שלילה) + δίκη (דיקה) = צדק"
  },
  "G154": {
    m: "לבקש, להתחנן, להפציר",
    d: "לבקש, להתחנן למשהו, להפציר, לעתור. בקשה ענווה ומכובדת.",
    u: "משמש 70 פעמים בברית החדשה. בקשה הפונה לאלוהים או לבני אדם.",
    e: "מ-αἰτέω (איטאו) שורש ראשוני; לבקש"
  },
  "G166": {
    m: "נצחי, תמידי",
    d: "ללא התחלה וסוף, קיים תמיד; בברית החדשה, מקושר לעתים קרובות לחיים נצחיים באלוהים.",
    u: "משמש 71 פעמים בברית החדשה. מאפיין לעתים קרובות חיים נצחיים ומלכות אלוהים.",
    e: "מ-αἰών (איון) = עידן, תקופה, נצח"
  },
  "G225": {
    m: "אמת, מציאות",
    d: "מה שאמיתי בדברים הנוגעים לאלוהים ולחובות האדם; האמת האלוהית המגולה.",
    u: "משמש 109 פעמים בברית החדשה. מושג מרכזי בהוראתו של ישוע.",
    e: "מ-ἀληθής (אלתס) = אמיתי, כן"
  },
  "G281": {
    m: "אמן, באמת",
    d: "נוסחת אישור: כן יהי, באמת, בוודאי.",
    u: "משמש 129 פעמים בברית החדשה. ישוע אומר 'אמן אמן'.",
    e: "מעברית אָמֵן (אמן) = איתן, נאמן"
  },
  "G444": {
    m: "אדם, בן אנוש",
    d: "בן אנוש, גבר או אישה; האנושות בכלל.",
    u: "משמש 550 פעמים בברית החדשה. האדם שנברא בצלם אלוהים.",
    e: "מ-ἀνήρ (אנר) = גבר ו-ὤψ (אופס) = פנים"
  },
  "G622": {
    m: "לאבד, להרוס, לאבוד",
    d: "להרוס לחלוטין; לאבד, לאבוד; להיהרס.",
    u: "משמש 90 פעמים בברית החדשה. להציל את מה שאבד.",
    e: "מ-ἀπό (אפו) = מ + ὄλλυμι (אולומי) = להרוס"
  },
  "G649": {
    m: "לשלוח, לשגר",
    d: "לשלוח עם שליחות; לשגר כשגריר.",
    u: "משמש 132 פעמים בברית החדשה. האב שולח את הבן.",
    e: "מ-ἀπό (אפו) = מ + στέλλω (סטלו) = לשלוח"
  },
  "G721": {
    m: "שה",
    d: "שה קטן; מציין את ישוע המשיח כשה האלוהים.",
    u: "משמש 30 פעמים בברית החדשה, במיוחד בהתגלות.",
    e: "צורה מוקטנת של ἀρήν (ארן) = שה"
  },
  "G730": {
    m: "זכר, גברי",
    d: "ממין זכר, זכר.",
    u: "משמש 9 פעמים בברית החדשה. אלוהים ברא את האדם זכר ונקבה.",
    e: "שורש ראשוני"
  },
  "G740": {
    m: "לחם",
    d: "לחם, מזון; לחם החיים = המשיח.",
    u: "משמש 97 פעמים בברית החדשה. ישוע לחם החיים.",
    e: "מ-ἄρω (ארו) = להרים, להגביה"
  },
  "G746": {
    m: "התחלה, מקור",
    d: "ההתחלה, המקור, העיקרון הראשון. ביוחנן 1:1-2, מציין את ההתחלה הנצחית שבה כבר קיימת הדבר (לוגוס).",
    u: "משמש 55 פעמים בברית החדשה. מילת המפתח של יוחנן 1:1 'בתחילה היה הדבר'.",
    e: "מילה ראשונית; התחלה, מקור ראשון"
  },
  "G772": {
    m: "חלש, חולה",
    d: "ללא כוח, חלש; חולה, רפה; חלש רוחנית.",
    u: "משמש 25 פעמים בברית החדשה. אלוהים בחר בחלשי העולם.",
    e: "מ-ἀ- (שלילה) + σθένος (סתנוס) = כוח"
  },
  "G907": {
    m: "להטביל, לטבול",
    d: "לטבול במים; להטביל לטיהור או חניכה.",
    u: "משמש 77 פעמים בברית החדשה. הטבילה הנוצרית.",
    e: "מ-βάπτω (באפטו) = לטבול, להטביל"
  },
  "G1080": {
    m: "להוליד, להביא לחיים",
    d: "להוליד, ללדת; להיוולד מחדש רוחנית.",
    u: "משמש 97 פעמים בברית החדשה. להיוולד מאלוהים, להיוולד מחדש.",
    e: "שורש ראשוני"
  },
  "G1096": {
    m: "להיות, לקרות, להתרחש",
    d: "להיות, לבוא לקיומו, לקרות, להתקיים, להתרחש.",
    u: "משמש 678 פעמים בברית החדשה. 'כל דבר נהיה על ידו' (יוחנן א׳ 3).",
    e: "מ-γίνομαι (גינומאי) = להיות"
  },
  "G1097": {
    m: "לדעת, להבין",
    d: "לדעת מתוך ניסיון אישי; להבין, לתפוס, להיות מודע.",
    u: "משמש 222 פעמים בברית החדשה. ידיעה מניסיון, לא רק אינטלקטואלית.",
    e: "שורש הודו-אירופי *gen- = להוליד, לדעת"
  },
  "G1100": {
    m: "לשון, שפה",
    d: "איבר הדיבור; שפה, ניב; מתנת הלשונות.",
    u: "משמש 50 פעמים בברית החדשה. מתנת הלשונות.",
    e: "שורש ראשוני"
  },
  "G1166": {
    m: "להראות, להדגים",
    d: "לחשוף לעיניים, להראות; להוכיח, להדגים.",
    u: "משמש 33 פעמים בברית החדשה. אלוהים מראה את כבודו.",
    e: "שורש ראשוני"
  },
  "G1208": {
    m: "שני, משני",
    d: "השני בסדרה או בסדר.",
    u: "משמש 44 פעמים בברית החדשה. המצווה השנייה.",
    e: "מ-δύο (דיו) = שניים"
  },
  "G1271": {
    m: "שכל, מחשבה",
    d: "היכולת לחשוב, לשמוע, להבין; השכל, ההבנה.",
    u: "משמש 12 פעמים בברית החדשה. השכל המחודש על ידי המשיח.",
    e: "מ-διά (דיה) = דרך + νοῦς (נוס) = שכל"
  },
  "G1320": {
    m: "מורה, רב, מדריך",
    d: "מורה, מדריך; מי שמלמד אמיתות דתיות.",
    u: "משמש 59 פעמים בברית החדשה. 'רבי, יודעים אנחנו שמורה אתה שבא מאלהים' (יוחנן ג׳ 2).",
    e: "מ-διδάσκω (דידאסקו) = ללמד"
  },
  "G1325": {
    m: "לתת, להעניק",
    d: "לתת משהו למישהו; להעניק, להרשות; למסור.",
    u: "משמש 415 פעמים בברית החדשה. אלוהים נותן בנדיבות.",
    e: "שורש ראשוני"
  },
  "G1372": {
    m: "לצמוא, להשתוקק",
    d: "לסבול מצמא; להשתוקק בלהט, לכמוה.",
    u: "משמש 16 פעמים בברית החדשה. צמא רוחני לאלוהים.",
    e: "מ-δίψα (דיפסה) = צמא"
  },
  "G1401": {
    m: "עבד, משרת",
    d: "עבד, משרת; עבד רצוני של אלוהים.",
    u: "משמש 124 פעמים בברית החדשה. עבדי המשיח.",
    e: "מ-δέω (דאו) = לקשור"
  },
  "G1411": {
    m: "כוח, עוצמה, נס",
    d: "כוח, עוצמה, יכולת; מעשה עוצמה, נס.",
    u: "משמש 120 פעמים בברית החדשה. כוחו של אלוהים, של רוח הקודש.",
    e: "מ-δύναμαι (דינמאי) = להיות מסוגל"
  },
  "G1417": {
    m: "שניים",
    d: "המספר שניים; זוג.",
    u: "משמש 135 פעמים בברית החדשה. שניים או שלושה עדים.",
    e: "שורש ראשוני"
  },
  "G1473": {
    m: "אני, אותי",
    d: "כינוי גוף ראשון יחיד.",
    u: "משמש 2567 פעמים בברית החדשה. נפוץ מאוד.",
    e: "כינוי ראשוני"
  },
  "G1484": {
    m: "עם, אומה, גויים",
    d: "עם, אומה; העמים הגויים (לא-יהודים).",
    u: "משמש 162 פעמים בברית החדשה. הבשורה לכל העמים.",
    e: "שורש ראשוני"
  },
  "G1492": {
    m: "לדעת, לראות, להבין",
    d: "לדעת דרך תפיסה, לראות, להבין, להכיר. ידע שנרכש דרך ניסיון או התגלות.",
    u: "משמש 666 פעמים בברית החדשה. פועל הידע הבסיסי בבשורת יוחנן.",
    e: "צורת שלמות של εἴδω (איידו); לראות, לדעת"
  },
  "G1510": {
    m: "להיות, להתקיים",
    d: "הפועל להיות בכל משמעויותיו; להתקיים, להישאר, להתרחש.",
    u: "הפועל הנפוץ ביותר בברית החדשה (2460+ פעמים).",
    e: "שורש ראשוני"
  },
  "G1515": {
    m: "שלום",
    d: "מצב של שלווה; שלום עם אלוהים; הרמוניה בין אנשים.",
    u: "משמש 92 פעמים בברית החדשה. שלומו של המשיח.",
    e: "מ-εἴρω (אירו) = לחבר, לקשור"
  },
  "G1520": {
    m: "אחד, יחיד",
    d: "אחד בלבד; יחיד, רק; מסוים.",
    u: "משמש 344 פעמים בברית החדשה. אחדות האלוהים, הכנסייה המאוחדת.",
    e: "שורש ראשוני"
  },
  "G1586": {
    m: "לבחור, לבור",
    d: "לבחור לעצמו, לברור; לבור בחסד אלוהי.",
    u: "משמש 21 פעמים בברית החדשה. אלוהים בוחר את בניו.",
    e: "מ-ἐκ (אק) = מתוך + λέγω (לגו) = לבחור"
  },
  "G1658": {
    m: "חופשי, משוחרר",
    d: "חופשי, לא עבד; משוחרר מעבדות החטא.",
    u: "משמש 23 פעמים בברית החדשה. משוחררים במשיח.",
    e: "כנראה מ-ἔρχομαι (ארכומאי) = לבוא"
  },
  "G1672": {
    m: "יווני, גוי",
    d: "יווני לפי לידה או שפה; לא-יהודי.",
    u: "משמש 25 פעמים בברית החדשה. לא יהודי ולא יווני במשיח.",
    e: "מ-Ἑλλάς (הלס) = יוון"
  },
  "G1680": {
    m: "תקווה, ציפייה בטוחה",
    d: "ציפייה לדברים טובים, תקווה המבוססת על אלוהים; ביטחון בעתיד המבוסס על הבטחות אלוהיות.",
    u: "משמש 54 פעמים בברית החדשה. אחת משלוש המידות התיאולוגיות עם אמונה ואהבה.",
    e: "מ-ἔλπω (אלפו) = לחכות, לקוות"
  },
  "G1743": {
    m: "לחזק, להפוך לחזק",
    d: "להפוך לחזק, לחזק; לתת עוצמה.",
    u: "משמש 8 פעמים בברית החדשה. אלוהים מחזק את המאמינים.",
    e: "מ-ἐν (אן) = ב + δυναμόω (דינמוו) = לעשות עצום"
  },
  "G1746": {
    m: "ללבוש, להתלבש",
    d: "ללבוש בגד; להתלבש בתכונה או בכוח.",
    u: "משמש 27 פעמים בברית החדשה. ללבוש את המשיח, ללבוש את שריון האלוהים.",
    e: "מ-ἐν (אן) = ב + δύω (דיו) = להיכנס, ללבוש"
  },
  "G1785": {
    m: "מצווה, פקודה",
    d: "פקודה, מצווה, תקנה; במיוחד מצווה אלוהית.",
    u: "משמש 67 פעמים בברית החדשה. מצוות האלוהים והמשיח.",
    e: "מ-ἐντέλλομαι (אנטלומאי) = לצוות"
  },
  "G1848": {
    m: "לבוז, להתייחס בבוז",
    d: "להתייחס כאל כלום, לבוז; להתייחס בזלזול.",
    u: "משמש 11 פעמים בברית החדשה. העולם בז למה שאלוהים בוחר.",
    e: "מ-ἐξ (אקס) = מ + οὐθείς (אותייס) = איש"
  },
  "G2041": {
    m: "מעשה, עבודה, פעולה",
    d: "עבודה, עמל; פעולה, מעשה; עבודה שבוצעה.",
    u: "משמש 169 פעמים בברית החדשה. מעשי אלוהים, מעשים טובים.",
    e: "מ-ἔργω (ארגו) = לעבוד"
  },
  "G2048": {
    m: "מדבר, שומם",
    d: "מקום שומם, מדבר; בודד, לא מיושב.",
    u: "משמש 48 פעמים בברית החדשה. 40 הימים של ישוע במדבר.",
    e: "מ-ἔρημος (ארמוס) = נטוש"
  },
  "G2065": {
    m: "לשאול, לחקור, לברר",
    d: "לשאול, לחקור, לברר למטרת קבלת מידע. חקירה או בירור.",
    u: "משמש 63 פעמים בברית החדשה. שאילה לקבלת תשובות.",
    e: "שורש לא ודאי; לשאול, לחקור"
  },
  "G2189": {
    m: "איבה, עוינות",
    d: "שנאה, עוינות, איבה.",
    u: "משמש 6 פעמים בברית החדשה. האיבה עם אלוהים בוטלה.",
    e: "מ-ἐχθρός (אכתרוס) = אויב"
  },
  "G2205": {
    m: "קנאה, קנאות, קנאה רעה",
    d: "התלהבות נלהבת; יכול להיות חיובי (קנאה לאלוהים) או שלילי (קנאה, קנאה רעה).",
    u: "משמש 16 פעמים בברית החדשה. יכול להיות מעלה או חטא לפי ההקשר.",
    e: "מ-ζέω (זאו) = לרתוח, להיות נלהב"
  },
  "G2222": {
    m: "חיים",
    d: "חיים פיזיים או רוחניים; החיים הנצחיים באלוהים.",
    u: "משמש 135 פעמים בברית החדשה. ישוע הוא החיים.",
    e: "מ-ζάω (זאו) = לחיות"
  },
  "G2258": {
    m: "היה, הוא היה",
    d: "היה, הוא היה, היא הייתה. צורת עבר של הפועל להיות (εἰμί). מבטא מצב או קיום בעבר.",
    u: "משמש 267 פעמים בברית החדשה. מכריע ביוחנן 1:1 'בראשית היה הדבר'.",
    e: "עבר של εἰμί (איימי) = להיות; היה"
  },
  "G2296": {
    m: "להתפלא, להשתומם, להתפעל",
    d: "להתפלא, להשתומם, להיות מופתע, להתפעל. תגובת השתאות מול משהו יוצא דופן.",
    u: "משמש 43 פעמים בברית החדשה. תגובה תכופה לניסי ישוע ותורתו.",
    e: "מ-θαῦμα (תאומא) = נס; להתפלא"
  },
  "G2316": {
    m: "אלוהים, אלוהות",
    d: "האל האמיתי והיחיד, הישות העליונה והנצחית. בברית החדשה מתייחס לאלוהים האב, או ישוע המשיח הבן, או רוח הקודש - השילוש הקדוש.",
    u: "משמש 1343 פעמים בברית החדשה. המילה היסודית לציון האל האמיתי האחד באחדות השילוש.",
    e: "מקורה לא ברור לפי סטרונג. מציין אלוהות, במיוחד האלוהות העליונה. שימוש מקראי: חושף את האל החי הפועל בהיסטוריית הישועה."
  },
  "G2338": {
    m: "נקבה, נשי",
    d: "ממין נקבה, נקבה.",
    u: "משמש 5 פעמים בברית החדשה. גבר ואישה שווים במשיח.",
    e: "מ-θηλάζω (תלאזו) = להניק"
  },
  "G2362": {
    m: "כסא",
    d: "כסא מלכותי, כסא; כוח וסמכות מלכותית.",
    u: "משמש 62 פעמים בברית החדשה. כסא אלוהים והשה.",
    e: "שורש ראשוני"
  },
  "G2381": {
    m: "תומא",
    d: "תומא, שם פרטי. אחד מהשנים עשר השליחים, נקרא גם דידימוס (תאום). ידוע בדרישתו לראיות על התחייה.",
    u: "משמש 11 פעמים בברית החדשה. השליח שהטיל ספק ואז האמין.",
    e: "מהארמית תְּאוֹמָא (תאומא) = תאום"
  },
  "G2398": {
    m: "שלו, מיוחד, אישי",
    d: "שלו, מיוחד, אישי, פרטי. מה ששייך במפורש למישהו, נבדל מאחרים.",
    u: "משמש 114 פעמים בברית החדשה. מושג של בעלות אישית והבחנה.",
    e: "משורש לא ודאי; שלו, מיוחד"
  },
  "G2424": {
    m: "ישוע",
    d: "ישוע מנצרת, המשיח, המושיע.",
    u: "משמש 917 פעמים בברית החדשה. השם שמעל לכל שם.",
    e: "מעברית יְהוֹשֻׁעַ (יהושוע) = ה' מושיע"
  },
  "G2453": {
    m: "יהודי, יהודה",
    d: "שייך לגזע היהודי; תושב יהודה.",
    u: "משמש 195 פעמים בברית החדשה. היהודים, עם הבחירה של אלוהים.",
    e: "מ-Ἰούδας (יודס) = יהודה"
  },
  "G2491": {
    m: "יוחנן",
    d: "יוחנן, שם פרטי. יוחנן המטביל המבשר, יוחנן השליח האהוב, מחבר הבשורה והמכתבים.",
    u: "משמש 135 פעמים בברית החדשה. שם של שתי דמויות גדולות בברית החדשה.",
    e: "מהעברית יוֹחָנָן (יוחנן) = יהוה חנון"
  },
  "G2531": {
    m: "כמו, כפי ש",
    d: "כמו, באותו אופן ש; כפי ש, במידה ש.",
    u: "משמש 182 פעמים בברית החדשה. מילת קישור השוואתית.",
    e: "מ-κατά (קטה) = כפי + ὡς (הוס) = כמו"
  },
  "G2537": {
    m: "חדש, לאחרונה",
    d: "חדש בזמן או באיכות; רענן, לאחרונה, לא משומש.",
    u: "משמש 42 פעמים בברית החדשה. בריאה חדשה, מצווה חדשה.",
    e: "שורש לא ברור"
  },
  "G2570": {
    m: "טוב, יפה",
    d: "טוב בטבעו, יפה; מכובד, מצוין, בעל מידות.",
    u: "משמש 100 פעמים בברית החדשה. הרועה הטוב, המעשים הטובים.",
    e: "שורש ראשוני"
  },
  "G2588": {
    m: "לב",
    d: "הלב הפיזי; מרכז החיים הפנימיים, הנשמה, הרוח; המחשבות והרגשות.",
    u: "משמש 156 פעמים בברית החדשה. מושב החיים הרוחניים.",
    e: "שורש ראשוני"
  },
  "G2596": {
    m: "לפי, נגד, דרך",
    d: "מילת יחס עם משמעויות מרובות: לפי, בהתאם ל; נגד; דרך.",
    u: "משמש למעלה מ-470 פעמים בברית החדשה. מילת יחס נפוצה מאוד.",
    e: "מילת יחס ראשונית"
  },
  "G2617": {
    m: "להכלים, להשפיל",
    d: "להכלים, להשפיל; לבייש, להשפיל.",
    u: "משמש 13 פעמים בברית החדשה. אלוהים מבייש את חכמי העולם.",
    e: "מ-κατά (קטה) = נגד + αἰσχύνω (איסכינו) = להתבייש"
  },
  "G2744": {
    m: "להתפאר, להתגאות",
    d: "להתפאר, להתגאות; למצוא גאווה במשהו.",
    u: "משמש 37 פעמים בברית החדשה. להתפאר באדון.",
    e: "מ-καῦχος (קאוכוס) = התפארות"
  },
  "G2889": {
    m: "עולם, יקום, אנושות",
    d: "סדר העולם, היקום; האנושות הנופלת; המערכת המנוגדת לאלוהים.",
    u: "משמש 186 פעמים בברית החדשה. יכול לציין את הבריאה או את המערכת החוטאת.",
    e: "מ-κοσμέω (קוסמאו) = לקשט, לסדר"
  },
  "G2919": {
    m: "לשפוט, להחליט",
    d: "לשפוט, לתת משפט; להחליט, לקבוע.",
    u: "משמש 114 פעמים בברית החדשה. אלוהים שופט את העולם.",
    e: "שורש ראשוני"
  },
  "G2920": {
    m: "משפט, צדק, הרשעה",
    d: "משפט, צדק, הרשעה, החלטה שיפותית. משפט אלוהים, צודק ומושלם.",
    u: "משמש 47 פעמים בברית החדשה. מושג מרכזי של הצדק האלוהי.",
    e: "מ-κρίνω (קרינו) = לשפוט, להחליט"
  },
  "G2962": {
    m: "אדון, רב, בעלים",
    d: "אדון, רב; תואר כבוד וסמכות אלוהית; ישוע כאדון.",
    u: "משמש 748 פעמים בברית החדשה. 'אמר לו תומא: אדוני, לא ידענו אנה אתה הולך' (יוחנן יד 5).",
    e: "מ-κύριος (קוריוס) = בעל סמכות"
  },
  "G2992": {
    m: "עם",
    d: "עם, אומה; במיוחד עם האלוהים (ישראל או הקהילה).",
    u: "משמש 142 פעמים בברית החדשה. עם הבחירה של אלוהים.",
    e: "שורש ראשוני"
  },
  "G3022": {
    m: "לבן, זוהר",
    d: "לבן, מבריק; סמל טוהר וניצחון.",
    u: "משמש 25 פעמים בברית החדשה. הלבושים הלבנים של הנגאלים.",
    e: "מ-λευκός (לוקוס) = לבן, בהיר"
  },
  "G3056": {
    m: "דבר, מילה, שכל",
    d: "דבר מבוטא; שכל, אינטליגנציה; הלוגוס = המשיח.",
    u: "משמש 330 פעמים בברית החדשה. הלוגוס המתגלם.",
    e: "מ-λέγω (לגו) = לומר"
  },
  "G3101": {
    m: "תלמיד, לומד",
    d: "לומד, סטודנט, תלמיד; חסיד של ישוע.",
    u: "משמש 261 פעמים בברית החדשה. מציין את חסידי המשיח.",
    e: "מ-μανθάνω (מנתנו) = ללמוד"
  },
  "G3141": {
    m: "עדות, העדה",
    d: "עדות, העדה, הוכחה, ראיה. עדות הניתנת לאמת, במיוחד למשיח.",
    u: "משמש 37 פעמים בברית החדשה. נושא מרכזי בבשורת יוחנן.",
    e: "מ-μάρτυς (מארטוס) = עד"
  },
  "G3173": {
    m: "גדול, חשוב",
    d: "גדול בגודל, כמות או חשיבות; אדיר, נפלא.",
    u: "משמש 243 פעמים בברית החדשה. גדולתו של אלוהים.",
    e: "שורש ראשוני"
  },
  "G3320": {
    m: "קיר מפריד",
    d: "קיר אמצע, מחיצת הפרדה.",
    u: "משמש פעם אחת בברית החדשה (אפסים 2:14). הקיר בין יהודים לגויים.",
    e: "מ-μέσος (מסוס) = אמצע + τοῖχος (טויכוס) = קיר"
  },
  "G3439": {
    m: "יחיד, יחיד נולד",
    d: "ייחודי במינו, יחיד נולד; בן יחיד.",
    u: "משמש 9 פעמים בברית החדשה. בנו היחיד של אלוהים.",
    e: "מ-μόνος (מונוס) = יחיד + γίνομαι (גינומאי) = להיות"
  },
  "G3474": {
    m: "אִוֶּלֶת, סכלות",
    d: "אִוֶּלֶת, אבסורד; מה שחסר חכמה.",
    u: "משמש 5 פעמים בברית החדשה. חכמת אלוהים נראית כאִוֶּלֶת לעולם.",
    e: "מ-μωρός (מורוס) = טיפש, חסר הגיון"
  },
  "G3475": {
    m: "משה",
    d: "משה, מחוקק ישראל.",
    u: "משמש 80 פעמים בברית החדשה. תורת משה.",
    e: "מעברית מֹשֶׁה (משה) = נמשה (מן המים)"
  },
  "G3530": {
    m: "נקדימון",
    d: "נקדימון, שם פרטי. פרוש ומנהיג יהודי שבא אל ישוע בלילה. שם יווני הפירוש 'ניצחון העם'.",
    u: "משמש 5 פעמים בברית החדשה. דמות חשובה בבשורת יוחנן.",
    e: "מהיוונית νίκη (ניקה) = ניצחון ו-δῆμος (דמוס) = עם"
  },
  "G3551": {
    m: "תורה, חוק",
    d: "תורה, חוק, כלל, עיקרון. תורת משה, החוק האלוהי, מצוות אלוהים.",
    u: "משמש 194 פעמים בברית החדשה. מושג מרכזי של הגילוי האלוהי.",
    e: "מ-νέμω (נמו) = לחלק, לתת; חוק שניתן"
  },
  "G3571": {
    m: "לילה",
    d: "לילה, תקופת החושך בין שקיעה לזריחה. לעתים קרובות מטפורי לבורות רוחנית.",
    u: "משמש 61 פעמים בברית החדשה. מנוגד לאור בסמליות יוחנית.",
    e: "שם נקבה יסודי; לילה"
  },
  "G3598": {
    m: "דרך, נתיב",
    d: "כביש, דרך; אורח חיים, התנהגות; דרך הישועה.",
    u: "משמש 101 פעמים בברית החדשה. ישוע הוא הדרך.",
    e: "שורש ראשוני"
  },
  "G3609": {
    m: "ביתי, של הבית",
    d: "שייך לבית, בן משפחה; משרת ביתי.",
    u: "משמש 3 פעמים בברית החדשה. מתאר את בני משפחת האלוהים.",
    e: "מ-οἶκος (אויקוס) = בית"
  },
  "G3664": {
    m: "דומה, שווה",
    d: "דומה, מאותה טבע או אופי; שווה ערך.",
    u: "משמש 45 פעמים בברית החדשה. המצווה השנייה דומה לראשונה.",
    e: "מ-ὁμός (הומוס) = אותו"
  },
  "G3686": {
    m: "שם",
    d: "שם, תואר; מוניטין; סמכות, כוח.",
    u: "משמש 228 פעמים בברית החדשה. שמו של ישוע.",
    e: "שורש ראשוני"
  },
  "G3708": {
    m: "לראות, להביט",
    d: "לראות בעיניים; לתפוס, להבין; להופיע.",
    u: "משמש 454 פעמים בברית החדשה. לראות את המשיח, לראות את האב.",
    e: "שורש ראשוני"
  },
  "G3735": {
    m: "הר, גבעה",
    d: "הר, הר; גבעה גבוהה.",
    u: "משמש 63 פעמים בברית החדשה. הר ההשתנות.",
    e: "כנראה מ-ὁράω (הוראו) = לראות"
  },
  "G3756": {
    m: "לא, אל",
    d: "שלילה מוחלטת, לא, אל.",
    u: "משמש למעלה מ-1600 פעמים בברית החדשה. מילת שלילה נפוצה מאוד.",
    e: "מילת שלילה ראשונית"
  },
  "G3762": {
    m: "אף אחד, שום דבר, אין",
    d: "אף אחד, שום דבר, אין, לא אחד. שלילה מוחלטת של קיום או כמות.",
    u: "משמש 234 פעמים בברית החדשה. שלילה חזקה נפוצה מאוד.",
    e: "מ-οὐδέ (אודה) ו-εἷς (הייס); אפילו לא אחד"
  },
  "G3778": {
    m: "זה, זאת, הזה",
    d: "כינוי הוראה: זה, זאת, הזה. מציין משהו קרוב או שהוזכר קודם.",
    u: "משמש 1388 פעמים בברית החדשה. כינוי ההוראה הנפוץ ביותר.",
    e: "כינוי הוראה ראשוני"
  },
  "G3789": {
    m: "נחש",
    d: "נחש, זוחל; הנחש הקדמון (שטן).",
    u: "משמש 14 פעמים בברית החדשה. נחש הנחושת במדבר.",
    e: "שורש ראשוני"
  },
  "G3793": {
    m: "המון, רבים",
    d: "המון אנשים, רבים; ההמון העממי.",
    u: "משמש 175 פעמים בברית החדשה. ההמונים שעקבו אחר ישוע.",
    e: "מ-ὄχος (אוכוס) = כלי רכב (שנושא)"
  },
  "G3880": {
    m: "לקבל, לקחת, לקבל בברכה",
    d: "לקבל, לקחת, לקבל בברכה, לתפוס. לקבל משהו המוצע או ניתן.",
    u: "משמש 59 פעמים בברית החדשה. מושג מרכזי של קבלת הבשורה.",
    e: "מ-παρά (פארא) = לצד ו-λαμβάνω (למבנו) = לקחת"
  },
  "G3956": {
    m: "כל, כל אחד",
    d: "כל, כל אחד, כולם; הכלל, הסך הכל.",
    u: "משמש 1244 פעמים בברית החדשה. בין המילים הנפוצות ביותר.",
    e: "שורש ראשוני"
  },
  "G3962": {
    m: "אב",
    d: "אב טבעי או רוחני; אב קדמון; אלוהים האב.",
    u: "משמש 413 פעמים בברית החדשה. לעתים קרובות לציון אלוהים.",
    e: "שורש ראשוני קשור ללטינית 'pater'"
  },
  "G4100": {
    m: "להאמין, להיות אמונה",
    d: "להאמין ב, להיות אמונה; לבטוח, להישען על.",
    u: "משמש 241 פעמים בברית החדשה. להאמין בישוע כדי להיוושע.",
    e: "מ-πίστις (פיסטיס) = אמונה"
  },
  "G4102": {
    m: "אמונה, אמון, נאמנות",
    d: "הרשעה באמיתות של דבר מה, אמונה; בברית החדשה הרשעה הנוגעת ליחסי האדם עם אלוהים ועם דברים אלוהיים.",
    u: "משמש 244 פעמים בברית החדשה. מושג מרכזי באמונה המשיחית.",
    e: "מ-πείθω (פייתו) = לשכנע, להאמין"
  },
  "G4138": {
    m: "מלואות, שפע, מה שממלא",
    d: "מלואות, שפע, מה שממלא לחלוטין. השלמות, הגשמה אלוהית.",
    u: "משמש 17 פעמים בברית החדשה. מושג תיאולוגי של מלואות אלוהית במשיח.",
    e: "מ-πλήρης (פלרס) = מלא; מלואות"
  },
  "G4139": {
    m: "זולת, שכן",
    d: "מי שקרוב, שכן; הזולת באופן כללי.",
    u: "משמש 17 פעמים בברית החדשה. 'אהבת לרעך כמוך'.",
    e: "תואר שהפך שם, מ-πλησίος (פלסיוס) = קרוב"
  },
  "G4151": {
    m: "רוח, נשימה, רוח",
    d: "נשימת החיים, העיקרון החיוני; הנשמה הרציונלית; רוח הקודש.",
    u: "משמש 385 פעמים בברית החדשה. מציין רוח הקודש, רוח אנושית או רוחות.",
    e: "מ-πνέω (פנאו) = לנשוב, לנשום"
  },
  "G4160": {
    m: "לעשות, לבצע, להשלים",
    d: "לעשות, לבצע, לייצר, לפעול, לברוא. פועל פעולה כללי המכסה כל סוג של פעילות.",
    u: "משמש 568 פעמים בברית החדשה. פועל פעולה בסיסי, לעתים קרובות במעשי אלוהים.",
    e: "פועל ראשוני; לעשות, לבצע"
  },
  "G4166": {
    m: "רועה, כומר",
    d: "מי ששומר על הצאן; מנהיג רוחני, כומר קהילה.",
    u: "משמש 18 פעמים בברית החדשה. ישוע הרועה הטוב.",
    e: "מ-ποίμνη (פוימנה) = עדר"
  },
  "G4183": {
    m: "הרבה, רבים, גדול",
    d: "הרבה, רבים, גדול בכמות או במספר. המון, כמות גדולה.",
    u: "משמש 416 פעמים בברית החדשה. תואר כמותי תכוף מאוד.",
    e: "שורש לא ודאי; הרבה, רבים"
  },
  "G4198": {
    m: "ללכת, להליך, לנסוע",
    d: "ללכת, להליך, לנסוע, לזוז. תנועה ממקום למקום, לעתים קרובות עם מטרה.",
    u: "משמש 154 פעמים בברית החדשה. פועל תנועה יסודי בסיפורי הבשורות.",
    e: "פועל יסודי; ללכת, להליך"
  },
  "G4238": {
    m: "לעשות, לתרגל, לבצע",
    d: "לעשות, לתרגל, לבצע, לפעול. ביצוע פעולות, לעתים קרובות עם רעיון של חזרה או הרגל.",
    u: "משמש 39 פעמים בברית החדשה. לעתים קרובות קשור לתרגול הטוב או הרע.",
    e: "צורה מחוזקת של πράω (פראו); לעשות, לתרגל"
  },
  "G4263": {
    m: "כבשה, כבש",
    d: "כבשה או כבש; במטפורה, תלמידי המשיח.",
    u: "משמש 39 פעמים בברית החדשה. המאמינים כצאן הרועה.",
    e: "כנראה קשור ל-προβαίνω (פרובאינו) = להתקדם"
  },
  "G4413": {
    m: "ראשון, עיקרי",
    d: "ראשון בזמן, מקום, סדר או חשיבות.",
    u: "משמש 155 פעמים בברית החדשה. המצווה הראשונה, המקום הראשון.",
    e: "מופלג של πρό (פרו) = לפני"
  },
  "G4561": {
    m: "בשר, גוף",
    d: "בשר, בשר; גוף האדם; הטבע האנושי הנופל.",
    u: "משמש 147 פעמים בברית החדשה. ניגוד בין בשר ורוח.",
    e: "שורש ראשוני"
  },
  "G4592": {
    m: "אות, נס, מופת",
    d: "אות, נס, מופת; התגלות על-טבעית החושפת כוח אלוהי.",
    u: "משמש 77 פעמים בברית החדשה. 'כי אין איש יכול לעשות האותות האלה אשר אתה עושה' (יוחנן ג׳ 2).",
    e: "מ-σημεῖον (סמיון) = סימן, אות"
  },
  "G4648": {
    m: "להביט בקפידה, לכוון",
    d: "לקבע את העיניים על, לשקול בקפידה; לכוון למטרה.",
    u: "משמש 6 פעמים בברית החדשה. קריאה לקבע את העיניים על המשיח.",
    e: "קשור ל-σκοπός (סקופוס) = מטרה, יעד"
  },
  "G4680": {
    m: "חכם, משכיל",
    d: "חכם, אינטליגנטי, מיומן; משכיל, למד.",
    u: "משמש 22 פעמים בברית החדשה. החכמה האמיתית באה מאלוהים.",
    e: "שורש ראשוני"
  },
  "G4982": {
    m: "להושיע, להציל",
    d: "להציל מסכנה או הרס; להושיע מחטא.",
    u: "משמש 106 פעמים בברית החדשה. ישוע מושיע את החוטאים.",
    e: "מ-σῶς (סוס) = שלם ובריא"
  },
  "G5040": {
    m: "ילד קטן",
    d: "ילד קטן, תינוק; כינוי חיבה לתלמיד.",
    u: "משמש 8 פעמים בברית החדשה. יוחנן קורא לקוראיו 'ילדים קטנים'.",
    e: "צורה מוקטנת של τέκνον (טקנון) = ילד"
  },
  "G5087": {
    m: "לשים, להניח, להקים",
    d: "להניח, לשים; להקים, למנות; להפקיד, להניח.",
    u: "משמש 100 פעמים בברית החדשה. להניח את חייו בעד הצאן.",
    e: "שורש ראשוני"
  },
  "G5109": {
    m: "קיר",
    d: "קיר הפרדה, מחיצה.",
    u: "משמש פעם אחת בברית החדשה (מעשי השליחים 23:3).",
    e: "שורש ראשוני"
  },
  "G5207": {
    m: "בן",
    d: "צאצא זכר; תלמיד; חבר קבוצה. בן האלוהים = ישוע המשיח.",
    u: "משמש 377 פעמים בברית החדשה. לעתים קרובות לציון ישוע כבן האלוהים.",
    e: "מקור לא ברור, אולי קשור ל-ὕω (היו) = להמטיר, להוליד"
  },
  "G5281": {
    m: "סבלנות, סיבולת, התמדה",
    d: "תכונת מי שאינו נכנע לנסיבות או ללחצים; סבלנות סובלנית, יציבות.",
    u: "משמש 32 פעמים בברית החדשה. מידה משיחית חיונית.",
    e: "מ-ὑπό (היפו) = מתחת ו-μένω (מנו) = להישאר"
  },
  "G5312": {
    m: "להרים, לרומם",
    d: "להרים גבוה, להגביה; לרומם, לכבד.",
    u: "משמש 20 פעמים בברית החדשה. בן האדם המורם.",
    e: "מ-ὕψος (היפסוס) = גובה"
  },
  "G5376": {
    m: "פיליפוס",
    d: "פיליפוס, שם פרטי. אחד מהשנים עשר השליחים. שם יווני הפירוש 'אוהב סוסים'.",
    u: "משמש 36 פעמים בברית החדשה. שם השליח והדיקון.",
    e: "מהיוונית φίλος (פילוס) = חבר ו-ἵππος (היפוס) = סוס"
  },
  "G5432": {
    m: "לשמור, להגן",
    d: "לשמור על ידי משמר צבאי; להגן, לשמר.",
    u: "משמש 4 פעמים בברית החדשה. שלום אלוהים שומר את לבנו.",
    e: "מ-φρουρός (פרורוס) = משמר, צופה"
  },
  "G5443": {
    m: "שבט, עדה",
    d: "שבט, משפחה; עם הצאצא מאב קדמון משותף.",
    u: "משמש 31 פעמים בברית החדשה. שנים-עשר שבטי ישראל.",
    e: "מ-φύω (פיו) = לייצר, לגדל"
  },
  "G5457": {
    m: "אור",
    d: "אור פיזי או רוחני; האמת האלוהית המגולה.",
    u: "משמש 73 פעמים בברית החדשה. ישוע אור העולם.",
    e: "מ-φάω (פאו) = להאיר"
  },
  "G5463": {
    m: "לשמוח, להיות שמח",
    d: "לשמוח, להיות מאושר; ברכה 'שמח' או 'שלום'.",
    u: "משמש 74 פעמים בברית החדשה. ציווי תכוף לשמוח במשיח.",
    e: "קשור ל-χάρις (כריס) = חסד"
  },
  "G5495": {
    m: "יד",
    d: "יד; כוח, סמכות; פעולה, עבודה.",
    u: "משמש 177 פעמים בברית החדשה. יד האלוהים, ידיו של ישוע.",
    e: "שורש ראשוני"
  },
  "G5544": {
    m: "טוב לב, נדיבות",
    d: "טוב לב במעשה, נדיבות מעשית; תכונת מי שמועיל, מיטיב לאחרים.",
    u: "משמש 10 פעמים בברית החדשה. פרי הרוח לפי גלטים 5:22.",
    e: "מ-χρηστός (כרסטוס) = טוב, מועיל, נדיב"
  },
  "G5547": {
    m: "משיח, משיח, המשוח",
    d: "המשוח, המשיח; תואר ישוע כמושיע המובטח.",
    u: "משמש 529 פעמים בברית החדשה. ישוע הוא המשיח.",
    e: "מ-χρίω (כריו) = למשוח"
  },
  "G5590": {
    m: "נפש, חיים",
    d: "נשימת החיים, הנפש החיונית; החיים עצמם; הנשמה האלמותית.",
    u: "משמש 105 פעמים בברית החדשה. החיים הרוחניים והנצחיים.",
    e: "מ-ψύχω (פסוכו) = לנשום, לרענן"
  },
  "H120": {
    m: "אדם, אנושות, אדם",
    d: "אדם, בן אנוש; האנושות; אדם האדם הראשון.",
    u: "משמש 562 פעמים בתנ\"ך. אלוהים ברא את האדם.",
    e: "מ-אָדֹם (אדום) = אדום, או אֲדָמָה (אדמה) = אדמה"
  },
  "H160": {
    m: "אהבה, חיבה",
    d: "אהבה, חיבה; מעשה אהבה.",
    u: "משמש 40 פעמים בתנ\"ך. אהבת אלוהים לעמו.",
    e: "מ-אָהַב (אהב) = לאהוב"
  },
  "H216": {
    m: "אור",
    d: "אור טבעי או רוחני; אושר, שגשוג.",
    u: "משמש 120 פעמים בתנ\"ך. 'יהי אור !'",
    e: "מ-אוֹר (אור) = להיות מואר"
  },
  "H430": {
    m: "אלוהים, אלים",
    d: "האל העליון (אלוהים); לעתים משמש לשופטים או לאלים זרים.",
    u: "משמש 2606 פעמים בתנ\"ך. שם רבים של הוד לאלוהים.",
    e: "רבים של אֱלוֹהַּ (אלוה) = אל"
  },
  "H559": {
    m: "לאמר, לדבר",
    d: "לאמר, לדבר, להכריז; לצוות, לחשוב.",
    u: "משמש 5316 פעמים בתנ\"ך. הפועל הנפוץ ביותר של דיבור.",
    e: "שורש ראשוני"
  },
  "H776": {
    m: "ארץ, מדינה",
    d: "ארץ, קרקע; מדינה, אזור; העולם הארצי.",
    u: "משמש 2504 פעמים בתנ\"ך. הארץ שאלוהים ברא.",
    e: "שורש ראשוני"
  },
  "H982": {
    m: "לבטוח, להאמין",
    d: "לבטוח ב, להאמין; להיות בטוח.",
    u: "משמש 120 פעמים בתנ\"ך. ביטחון בה'.",
    e: "שורש ראשוני"
  },
  "H1004": {
    m: "בית, משכן",
    d: "בית, דירה; משפחה, בני בית; בית המקדש.",
    u: "משמש 2055 פעמים בתנ\"ך. בית ה'.",
    e: "מ-בָּנָה (בנה) = לבנות"
  },
  "H1254": {
    m: "לברוא",
    d: "לברוא מאין; ליצור, לעשות; פעילות בלעדית של אלוהים.",
    u: "משמש 54 פעמים בתנ\"ך. אלוהים ברא את השמים ואת הארץ.",
    e: "שורש ראשוני"
  },
  "H1516": {
    m: "עמק, גיא",
    d: "עמק, ערוץ, גיא; מישור.",
    u: "משמש 60 פעמים בתנ\"ך. גיא צלמוות.",
    e: "שורש ראשוני"
  },
  "H1878": {
    m: "לפטם, לעשות שמן",
    d: "לעשות שמן, לפטם; לשגשג.",
    u: "משמש 11 פעמים בתנ\"ך. דשנת בשמן ראשי.",
    e: "מ-דֶּשֶׁן (דשן) = שומן, אפר"
  },
  "H1980": {
    m: "ללכת, ללכת",
    d: "ללכת, ללכת, לבוא; לחיות, להתנהג.",
    u: "משמש 1554 פעמים בתנ\"ך. פועל תנועה נפוץ מאוד.",
    e: "שורש ראשוני"
  },
  "H2617": {
    m: "חסד, רחמים, נאמנות",
    d: "חסד, רחמים; נאמנות לברית; אהבה נאמנה.",
    u: "משמש 248 פעמים בתנ\"ך. חסד ה'.",
    e: "מ-חָסַד (חסד) = להיות טוב, רחום"
  },
  "H2637": {
    m: "לחסר, להיזקק",
    d: "לחסר, להיזקק; להתמעט, להעדר.",
    u: "משמש 23 פעמים בתנ\"ך. לא אחסר (תהלים כג:א).",
    e: "שורש ראשוני"
  },
  "H2896": {
    m: "טוב, נחמד",
    d: "טוב, נעים, מצוין; נדיב, צודק.",
    u: "משמש 559 פעמים בתנ\"ך. אלוהים ראה כי טוב.",
    e: "שורש ראשוני"
  },
  "H3068": {
    m: "ה', יהוה, אדון",
    d: "השם האישי של אלוהים, הטטרגרמטון הקדוש יהוה.",
    u: "משמש 6828 פעמים בתנ\"ך. השם הקדוש ביותר.",
    e: "מ-הָיָה (היה) = להיות, להתקיים"
  },
  "H3117": {
    m: "יום",
    d: "יום (ההפך מלילה); תקופה של 24 שעות; עידן, זמן.",
    u: "משמש 2301 פעמים בתנ\"ך. היום שה' עשה.",
    e: "מ-יוֹם (יום) = להיות חם"
  },
  "H3372": {
    m: "לפחד, לירא, ליראה",
    d: "לפחד, לירא; ליראה, לכבד את אלוהים.",
    u: "משמש 335 פעמים בתנ\"ך. לא אירא רע.",
    e: "שורש ראשוני"
  },
  "H3563": {
    m: "כוס, גביע",
    d: "כוס, גביע; מנה, גורל.",
    u: "משמש 31 פעמים בתנ\"ך. כוסי רויה.",
    e: "שורש ראשוני"
  },
  "H3820": {
    m: "לב, רוח",
    d: "לב, מושב הרגשות; רוח, שכל, רצון.",
    u: "משמש 598 פעמים בתנ\"ך. לב האדם.",
    e: "שורש ראשוני"
  },
  "H3915": {
    m: "לילה",
    d: "לילה (ההפך מיום); זמן חושך.",
    u: "משמש 234 פעמים בתנ\"ך. אלוהים הפריד את היום והלילה.",
    e: "שורש ראשוני"
  },
  "H3966": {
    m: "מאוד, ביותר",
    d: "מאוד, ביותר, הרבה; בכוח, במהירות.",
    u: "משמש 300 פעמים בתנ\"ך. זה היה טוב מאוד.",
    e: "מ-מָאַד (מאד) = להיות רב"
  },
  "H4325": {
    m: "מים, מימים",
    d: "מים, מימים; גשם; זרם, ים.",
    u: "משמש 585 פעמים בתנ\"ך. המים של הבריאה.",
    e: "זוגי של מַיִם (מים) = מים"
  },
  "H4999": {
    m: "מרעה, משכן",
    d: "מקום מרעה, אחו; משכן, דירה.",
    u: "משמש 13 פעמים בתנ\"ך. במרעי דשא.",
    e: "מ-נָאָה (נאה) = להיות יפה, מתאים"
  },
  "H5148": {
    m: "להנהיג, להדריך",
    d: "להנהיג, להדריך, להורות; להוביל בבטחה.",
    u: "משמש 40 פעמים בתנ\"ך. הוא ינחני (תהלים כג:ג).",
    e: "שורש ראשוני"
  },
  "H5216": {
    m: "מרעה, אדמה מעובדת",
    d: "מרעה, מרעה; אדמה מעובדת, שדה.",
    u: "משמש 2 פעמים בתנ\"ך. מרעי דשא.",
    e: "מ-נִיר (ניר) = לחרוש"
  },
  "H5315": {
    m: "נפש, חיים, אדם",
    d: "נפש, חיים, יצור חי; אדם, עצמי; תאווה, תיאבון.",
    u: "משמש 753 פעמים בתנ\"ך. נפשי, חיי.",
    e: "מ-נָפַשׁ (נפש) = לנשום"
  },
  "H5769": {
    m: "נצח, לעולם",
    d: "זמן בלתי מוגדר, נצח; לעולם, נצחיות.",
    u: "משמש 439 פעמים בתנ\"ך. אהבת האלוהים הנצחית.",
    e: "מ-עָלַם (עלם) = להסתיר, להיות נסתר"
  },
  "H6186": {
    m: "לסדר, להסדיר",
    d: "לסדר בסדר, להסדיר; להכין שולחן.",
    u: "משמש 75 פעמים בתנ\"ך. תערוך שולחן (תהלים כג:ה).",
    e: "שורש ראשוני"
  },
  "H6213": {
    m: "לעשות, לבצע",
    d: "לעשות, לייצר, לבצע; לפעול, לעבוד.",
    u: "משמש 2632 פעמים בתנ\"ך. פועל נפוץ מאוד.",
    e: "שורש ראשוני"
  },
  "H6664": {
    m: "צדק, יושר",
    d: "צדק, יושר, הגינות; נאמנות.",
    u: "משמש 119 פעמים בתנ\"ך. מעגלי צדק.",
    e: "מ-צָדַק (צדק) = להיות צודק"
  },
  "H6754": {
    m: "צלם, דמות",
    d: "צלם, דמות; צורה, מראה.",
    u: "משמש 17 פעמים בתנ\"ך. האדם נברא בצלם אלוהים.",
    e: "מ-צָלַל (צלל) = להצל, להידמות"
  },
  "H6757": {
    m: "צלמוות, חושך עמוק",
    d: "חושך עמוק, חשכה קטלנית; צל מוות.",
    u: "משמש 18 פעמים בתנ\"ך. מסמל סכנה קיצונית.",
    e: "מ-צֵל (צל) = צל + מָוֶת (מוות) = מוות"
  },
  "H6887": {
    m: "להיות במצוקה, יריב",
    d: "להיות דחוק, במצוקה; יריב, אויב.",
    u: "משמש 58 פעמים בתנ\"ך. נגד צוררי.",
    e: "שורש ראשוני"
  },
  "H7121": {
    m: "לקרוא, לצעוק, להכריז",
    d: "לקרוא, לצעוק; לכנות; להכריז, לזמן.",
    u: "משמש 736 פעמים בתנ\"ך. לקרוא בשם ה'.",
    e: "שורש ראשוני"
  },
  "H7200": {
    m: "לראות, להביט",
    d: "לראות בעיניים; לתפוס, להבין; לספק.",
    u: "משמש 1311 פעמים בתנ\"ך. אלוהים ראה כי טוב.",
    e: "שורש ראשוני"
  },
  "H7225": {
    m: "ראשית, ביכורים",
    d: "התחלה, ראשית; הטוב ביותר, ביכורים.",
    u: "משמש 51 פעמים בתנ\"ך. 'בראשית ברא אלוהים...'",
    e: "מ-רֹאשׁ (רוש) = ראש, התחלה"
  },
  "H7257": {
    m: "לשכב, לנוח",
    d: "לשכב, לנוח; לשכון; לדגור.",
    u: "משמש 30 פעמים בתנ\"ך. הוא ירביצני (תהלים כג:ב).",
    e: "שורש ראשוני"
  },
  "H7291": {
    m: "לרדוף, לגרש",
    d: "לרדוף, לגרש; לרדוף; לעקוב מקרוב.",
    u: "משמש 144 פעמים בתנ\"ך. הטוב ירדפני.",
    e: "שורש ראשוני"
  },
  "H7307": {
    m: "רוח, נשימה, רוח",
    d: "נשימה, רוח; רוח אלוהים או האדם; מצב רוח.",
    u: "משמש 378 פעמים בתנ\"ך. רוח אלוהים.",
    e: "מ-רוּחַ (רוח) = לנשוב"
  },
  "H7462": {
    m: "לרעות, רועה, להאכיל",
    d: "לרעות עדר; להיות רועה; להאכיל, לדאוג.",
    u: "משמש 173 פעמים בתנ\"ך. ה' רועי.",
    e: "שורש ראשוני"
  },
  "H7549": {
    m: "רקיע, שמים",
    d: "רקיע, כיפת השמים, רקיע; השמים.",
    u: "משמש 17 פעמים בתנ\"ך. הרקיע בתוך המים.",
    e: "מ-רָקַע (רקע) = להרחיב, להכות"
  },
  "H7626": {
    m: "שבט, שבט",
    d: "מטה, שרביט; שבט, ענף משפחתי.",
    u: "משמש 190 פעמים בתנ\"ך. שבטך ומשענתך.",
    e: "מ-שָׁבַט (שבט) = להסתעף"
  },
  "H7725": {
    m: "לשוב, לחזור, לשחזר",
    d: "לשוב, לחזור; לשחזר, לחדש; לשוב בתשובה.",
    u: "משמש 1058 פעמים בתנ\"ך. לשחזר את נפשי.",
    e: "שורש ראשוני"
  },
  "H7979": {
    m: "שולחן",
    d: "שולחן לאכול; שולחן לחם הפנים.",
    u: "משמש 71 פעמים בתנ\"ך. השולחן הערוך.",
    e: "מ-שָׁלַח (שלח) = לשלוח, להושיט"
  },
  "H8064": {
    m: "שמים, שמיים",
    d: "שמים, רקיע; משכן אלוהים; שמים נראים.",
    u: "משמש 420 פעמים בתנ\"ך. השמים והארץ.",
    e: "זוגי של שָׁמַיִם (שמים) = גבהים"
  },
  "H8414": {
    m: "תֹהוּ, ריק, כאוס",
    d: "מדבר, שממה; כאוס, ריק, אין.",
    u: "משמש 20 פעמים בתנ\"ך. הארץ הייתה תֹהוּ ובֹהוּ.",
    e: "מ-תָּהָה (תהה) = לשוטט"
  }
};

export default strongTranslationsHE;
